import { lazyVue } from "@/utils";
export default [
    {
        path: '/serviceType',
        name: 'serviceType',
        title: '分类',
        component: lazyVue('serviceType/index'),
        meta: {
            showBar:1,
            title: '分类',
            name: '分类'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/serviceType/index.js